import { useGlobalContext } from '../../../context/global';
import { type ISupportChatPanelData } from '../../../interface/peer-chat';
import { DESK_COUNTERPART } from '../../../interface/support-chat';
import ChatConversation from './ChatConversation';

/**
 * The agent's support conversation.
 *
 * <p>Titled "Support desk", never the name of whichever admin replied: admins rotate through
 * the desk and the agent is talking to a function, not a person. Individual names appear on
 * messages.</p>
 *
 * <p>Everything else is {@link ChatConversation}, bound to the support engine the layout owns.</p>
 */
const SupportChatPanel = () => {
	const { supportChat, rsProps } = useGlobalContext();
	if (!supportChat) return null;

	// A peer conversation escalating to the desk seeds the first line. The draft is read once,
	// on mount, into an untouched composer and is never sent on the agent's behalf.
	const seedDraft = (rsProps?.data as ISupportChatPanelData | null)?.seedDraft;

	return (
		<ChatConversation
			thread={supportChat}
			counterpart={DESK_COUNTERPART}
			seedDraft={seedDraft}
		/>
	);
};

export default SupportChatPanel;
